import Swal from "sweetalert2";
import { btnPositive, btnNegative, lblConfirm, lblConfirmDelete, lblConfirmDeleteWarning } from "../lang";

const confirmButtonColor = "#3085d6";
const cancelButtonColor = "#d33";

const popupSuccess = (options = {}, callback) => {
  const { text, timer, didOpen } = options;
  const didOpenFn = typeof didOpen === "function" ? didOpen : undefined;

  const cfg = {
    icon: "success",
    title: "Success",
    text,
  };

  if (typeof timer !== "undefined") cfg.timer = timer;
  if (typeof didOpenFn !== "undefined") cfg.didOpen = didOpenFn;

  return callback ? Swal.fire(cfg).then(callback) : Swal.fire(cfg);
}

const confirmPopup = ({
  confirmButtonText = btnPositive,
  cancelButtonText = btnNegative,
  icon = "question",
  text,
  title = lblConfirm,
  showCancelButton = true,
  allowOutsideClick = false,
  reverseButtons = false }, callback) => {

  const textProp = text ? { text } : {};
  return Swal.fire({
    title,
    icon,
    ...textProp,
    confirmButtonColor,
    cancelButtonColor,
    confirmButtonText,
    cancelButtonText,
    showCancelButton,
    allowOutsideClick,
    reverseButtons,
  }).then(callback);
};

/**
 * Generic popup to confirm deletion of something.
 * @param {Function} confirmCallback To fire when confirming deletion.
 * @returns {Promise}
 */
export const popupConfirmDelete = (confirmCallback) => {
  return confirmPopup({
    confirmButtonText: lblConfirmDelete,
    icon: "question",
    title: lblConfirm
  }, confirmCallback);
}

/**
 * Popup confirming deletion with a warning icon.
 * @param {Function} confirmCallback To fire when confirming deletion.
 * @returns {Promise} 
 */
export const popupConfirmDeleteWarning = (confirmCallback) => {
  return confirmPopup({
    confirmButtonText: lblConfirmDelete,
    icon: "warning",
    title: lblConfirm,
    text: lblConfirmDeleteWarning
  }, confirmCallback);
}

/**
 * Generic loader popup of 3 seconds.
 * @param {string} text Text to show in popup.
 * @param {Function} popupCallback To fire after popup is closed.
 */
export const popupSuccessShowLoading = (text, popupCallback) => {
  popupSuccess({
    text,
    timer: 3000,
    didOpen: () => Swal.showLoading()
  }, popupCallback);
}

/**
 * Generic success popup with or without callback.
 * @param {string} text Text to show in popup.
 * @param {Function} popupCallback To fire after popup is closed.
 */
export const popupSuccessSimple = (text, popupCallback) => {
  if (popupCallback) {
    popupSuccess({ text }, popupCallback);
  } else {
    popupSuccess({ text });
  }
}
